import { enhancedApi } from 'src/api/enhanced-api';

/**
 * Banner text for the default layout.
 *
 * Maintenance intervals are announced by the backend, which returns only the
 * ones currently relevant for the association. They take precedence over the
 * permanent demo mode hint because they are time critical.
 */
export const useBanner = () => {
  const { data: info } = enhancedApi.useGetApiAssociationInfoQuery();
  const { data: maintenance } = enhancedApi.useGetApiMaintenanceQuery();

  // intervals may be stored without a message
  // (use the first one that has a message)
  const announced = maintenance?.find((interval) => interval.message);
  if (announced?.message) return announced.message;

  return info?.demoMode ? 'Demo' : undefined;
};
